<template>
  <!-- MODAL EDIT -->
  <b-modal
    id="modalPowerMeter"
    title="Power Meter"
    size="xl"
    ok-only
  >
    <b-row>
      <b-col cols="12">
        <b-card>
          <!-- table -->
          <b-table
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(graph)="data">
              <b-link
                v-b-modal="'modalPowerMeter'"
                @click="$refs.childref.getPowerMeter(data.item.devid)"
              ><feather-icon
                class="text-primary"
                icon="TrendingUpIcon"
                size="20"
              />{{ data.value }}
              </b-link>
            </template>
            <template #cell(connect)="data">
              <b-badge :variant="connect[1][data.value]">
                {{ connect[0][data.value] }}
              </b-badge>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <GraphPowerMeter
      ref="childref"
      @fetch="getGraphPowerMeter()"
    />
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BCard, BTable, BBadge, BLink,
} from 'bootstrap-vue'
import GraphPowerMeter from '@/views/StatisModal/Graph/GraphPowerMeter.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTable,
    BBadge,
    BLink,
    GraphPowerMeter,
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'graph', label: 'Graph', class: 'text-center' },
        {
          key: 'devbuilding', label: 'Building', sortable: true, class: 'text-left',
        },
        {
          key: 'devid', label: 'ID', sortable: true, class: 'text-left',
        },
        {
          key: 'volt', label: 'Volt', sortable: true, class: 'text-center',
        },
        {
          key: 'amp', label: 'Amp', sortable: true, class: 'text-center',
        },
        {
          key: 'kwatt', label: 'kW', sortable: true, class: 'text-center',
        },
        {
          key: 'kva', label: 'kVA', sortable: true, class: 'text-center',
        },
        {
          key: 'hz', label: 'HZ', sortable: true, class: 'text-center',
        },
        {
          key: 'pf', label: 'PF', sortable: true, class: 'text-center',
        },
        {
          key: 'connect', label: 'Connected', sortable: true, class: 'text-center',
        },
      ],
      perPage: '',
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      connect: [{
        Offline: 'non-connect', Online: 'connect',
      },
      {
        Offline: 'light-danger', Online: 'light-success',
      }],
      status: [{
        AbNormal: 'AbNormal', Gen: 'Gen', Main: 'Main', OFF: 'OFF', Running: 'Running', Alarm: 'Alarm', Normal: 'Normal', Trip: 'Trip', ON: 'ON', ONLINE: 'ONLINE', OFFLINE: 'OFFLINE', EmergencyCall: 'Emergency Call',
      },
      {
        AbNormal: 'danger', Gen: 'info', Main: 'success', OFF: 'danger', Running: 'success', Alarm: 'danger', Normal: 'success', Trip: 'warning', ON: 'success', ONLINE: 'success', OFFLINE: 'danger', EmergencyCall: 'danger',
      }],
    }
  },
  mounted() {
    this.getATS()
  },
  methods: {
    getATS() {
      axios
        .get('/get-tablePowerMeter')
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
          this.perPage = response.data.length
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.validationForm()
    },
  },
}
</script>

<style>

</style>
